export default __webpack_public_path__ + "static/media/aramexLogo@2x.8f4cbce5.png";